import React, { useState, useEffect } from "react";
import Credin from "../../assets/Credin Logo (1).svg";
import { useNavigate } from "react-router-dom";
import { url } from "../../App";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const translations = {
  ENGLISH: {
    borrowerName: "Borrower Name",
    borrowerFatherName: "Borrower Father's Name",
    borrowerAddress: "Borrower Address",
    borrowerMobile: "Borrower Mobile Number",
    borrowerCity: "Borrower City",
    borrowerState: "Borrower State",
    borrowerPincode: "Borrower Pincode",
    customerType: "Customer Type",
    verificationType: "Verification Type",
    select: "Select",
    salaried: "Salaried",
    selfEmployed: "Self Employed",
    officeBusiness: "Office/Business",
    residence: "Residence",
    resiCumBusiness: "Resi Cum Business",
  },
  HINDI: {
    borrowerName: "उधारकर्ता का नाम",
    borrowerFatherName: "उधारकर्ता के पिता का नाम",
    borrowerAddress: "उधारकर्ता का पता",
    borrowerMobile: "उधारकर्ता का मोबाइल नंबर",
    borrowerCity: "उधारकर्ता का शहर",
    borrowerState: "उधारकर्ता का राज्य",
    borrowerPincode: "उधारकर्ता का पिन कोड",
    customerType: "ग्राहक प्रकार",
    verificationType: "सत्यापन प्रकार",
    select: "चुनें",
    salaried: "वेतनभोगी",
    selfEmployed: "स्व-नियोजित",
    officeBusiness: "कार्यालय/व्यवसाय",
    residence: "निवास",
    resiCumBusiness: "निवास सह व्यवसाय",
  },
  GUJARATI: {
    borrowerName: "Borrower નું નામ",
    borrowerFatherName: "Borrower ના પિતાનું નામ",
    borrowerAddress: "Borrower Address",
    borrowerMobile: "Borrower Mobile Number",
    borrowerCity: "Borrower City",
    borrowerState: "Borrower State",
    borrowerPincode: "Borrower Pincode",
    customerType: "Customer Type",
    verificationType: "Verification Type",
    select: "પસંદ કરો",
    salaried: "વેતનદાર",
    selfEmployed: "સ્વ રોજગારી",
    officeBusiness: "ઓફિસ/વ્યવસાય",
    residence: "નિવાસ",
    resiCumBusiness: "નિવાસ કમ બિઝનેસ",
  },
};

export default function Page2() {
    const [cpvLanguage, setCpvLanguage] = useState("ENGLISH");
    // eslint-disable-next-line
    const [number, setnumber] = useState("");
    const [isDisabled, setisDisabled] = useState(true);

    useEffect(() => {
      const language = localStorage.getItem("cpvLanguage");
      console.log(language)
      setCpvLanguage(language);
      const Number = localStorage.getItem("number");
      setnumber(Number);

      if(Number){
      axios
      .post(url + "/api/fetch/cpv/mobile", {
        mobile: Number,
      })
      .then((res) => {
        console.log(res);
        if(res.data.data.auth===false){
          setisDisabled(false);
          toast.error(res.data.data.message)
        }
        else{
        setBorrowerName(
          ([
            res.data.data.details?.lead_firstname,
            res.data.data.details?.lead_middlename,
            res.data.data.details?.lead_lastname
          ].filter(Boolean).join(" ")) ||
          ([
            res.data.data.details?.borrower_firstname,
            res.data.data.details?.borrower_middlename,
            res.data.data.details?.borrower_lastname
          ].filter(Boolean).join(" "))
        );
        setBorrowerFatherName(res.data.data.details?.borrower_fathername);
        setBorrowerAddress((res.data.data.details?.lead_aadhaar_dump?.address) || (res.data.data.details?.borrower_permanent_address));
        setBorrowerMobile((res.data.data.details?.lead_mobile) || (res.data.data.details?.borrower_mobile));
        setBorrowerCity((res.data.data.details?.lead_aadhaar_dump?.split_address?.vtc) || (res.data.data.details?.borrower_permanent_city));
        setBorrowerState((res.data.data.details?.lead_aadhaar_dump?.split_address?.state) || (res.data.data.details?.borrower_permanent_state));
        setBorrowerPincode((res.data.data.details?.lead_aadhaar_dump?.split_address?.pincode) || (res.data.data.details?.borrower_permanent_pincode));
        setBorrowerUniqueNo((res.data.data.details?.lead_id) || (res.data.data.details?.borrower_uniqueno));
      }
      })
      .catch((err) => {
        console.log(err);
      });
    }
    else {
      console.error("No mobile number found");
    }
  }, []);

  const navigate = useNavigate();
  const [borrowerUniqueNo, setBorrowerUniqueNo] = useState("");
  const [borrowerName, setBorrowerName] = useState("");
  const [borrowerFatherName, setBorrowerFatherName] = useState("");
  const [borrowerAddress, setBorrowerAddress] = useState("");
  const [borrowerMobile, setBorrowerMobile] = useState("");
  const [borrowerCity, setBorrowerCity] = useState("");
  const [borrowerState, setBorrowerState] = useState("");
  const [borrowerPincode, setBorrowerPincode] = useState("");
  const [customerType, setCustomerType] = useState("");
  const [verificationType, setVerificationType] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(borrowerMobile);
    console.log(borrowerPincode);
    localStorage.setItem("BorrowerUniqueNoCPV", borrowerUniqueNo);
    localStorage.setItem("BorrowerNameCPV", borrowerName);
    localStorage.setItem("BorrowerFatherNameCPV", borrowerFatherName);
    localStorage.setItem("BorrowerAddressCPV", borrowerAddress);
    localStorage.setItem("BorrowerMobileCPV", borrowerMobile);
    localStorage.setItem("BorrowerCityCPV", borrowerCity);
    localStorage.setItem("BorrowerStateCPV", borrowerState);
    localStorage.setItem("BorrowerPincodeCPV", borrowerPincode);
    localStorage.setItem("CustomerTypeCPV", customerType);
    localStorage.setItem("VerificationTypeCPV", verificationType);
    if (verificationType === "Office/Business") {
      navigate("/3office");
    } 
    else if (verificationType === "Residence") {
      navigate("/3residence");
    }
    else{
      navigate("/3resi-cum-business");
    }
  };
  return (
    <div className="main-login">
      <div style={{ margin: "2rem" }}>
        <img src={Credin} alt="Credin Logo" width="150" />
      </div>
      <div className="container-login">
        <div
          style={{
            fontWeight: "bolder",
            fontSize: "1.5rem",
            margin: ".5rem 0",
          }}
        >
          Customer Details
        </div>
        <form onSubmit={handleSubmit}>
          <div className="div-login">
            <label>
            {translations[cpvLanguage].borrowerName} <span style={{ color: "red" }}>*</span>
              {/* Borrower Name <span style={{ color: "red" }}>*</span> */}
            </label>
            <input
              type="text"
              name="borrower-name"
              required
              value={borrowerName}
              disabled={isDisabled}
              onChange={(e) => setBorrowerName(e.target.value)}
            />
          </div>
          <div className="div-login">
          <label>{translations[cpvLanguage].borrowerFatherName} <span style={{ color: "red" }}>*</span></label>
            {/* <label>Borrower Father's Name <span style={{ color: "red" }}>*</span></label> */}
            <input
              type="text"
              name="borrower-father-name"
              required
              value={borrowerFatherName}
              onChange={(e) => setBorrowerFatherName(e.target.value)}
            />
          </div>
          <div className="div-login">
            {/* <label>
              Borrower Address<span style={{ color: "red" }}>*</span>
            </label> */}
            <label>{translations[cpvLanguage].borrowerAddress} <span style={{ color: "red" }}>*</span></label>
            <input
              type="text"
              name="borrower-address"
              required
              value={borrowerAddress}
              onChange={(e) => setBorrowerAddress(e.target.value)}
            />
          </div>
          <div className="div-login">
            {/* <label>
              Borrower Mobile Number <span style={{ color: "red" }}>*</span>
            </label> */}
            <label>{translations[cpvLanguage].borrowerMobile} <span style={{ color: "red" }}>*</span></label>
            <input
              type="number"
              required
              disabled={isDisabled}
              value={borrowerMobile}
              onChange={(e) => setBorrowerMobile(e.target.value)}
            />
          </div>
          <div className="div-login">
            {/* <label>
              Borrower City <span style={{ color: "red" }}>*</span>
            </label> */}
            <label>{translations[cpvLanguage].borrowerCity} <span style={{ color: "red" }}>*</span></label>
            <input
              type="text"
              required
              value={borrowerCity}
              onChange={(e) => setBorrowerCity(e.target.value)}
            />
          </div>
          <div className="div-login">
            {/* <label>
              Borrower State <span style={{ color: "red" }}>*</span>
            </label> */}
            <label>{translations[cpvLanguage].borrowerState} <span style={{ color: "red" }}>*</span></label>
            <input
              type="text"
              required
              value={borrowerState}
              onChange={(e) => setBorrowerState(e.target.value)}
            />
          </div>
          <div className="div-login">
            {/* <label>
              Borrower Pincode <span style={{ color: "red" }}>*</span>
            </label> */}
            <label>{translations[cpvLanguage].borrowerPincode} <span style={{ color: "red" }}>*</span></label>
            <input
              type="number"
              required
              value={borrowerPincode}
              onChange={(e) => setBorrowerPincode(e.target.value)}
            />
          </div>
          <div className="div-login">
            {/* <label>
              Customer Type <span style={{ color: "red" }}>*</span>
            </label> */}
            <label>{translations[cpvLanguage].customerType} <span style={{ color: "red" }}>*</span></label>
            <select
              required
              value={customerType}
              onChange={(e) => setCustomerType(e.target.value)}
            >
              <option value="">{translations[cpvLanguage].select}</option>
              <option value="Salaried">{translations[cpvLanguage].salaried}</option>
              <option value="Self Employed">{translations[cpvLanguage].selfEmployed}</option>
            </select>
          </div>
          <div className="div-login">
            {/* <label>
              Verification Type <span style={{ color: "red" }}>*</span>
            </label> */}
            <label>{translations[cpvLanguage].verificationType} <span style={{ color: "red" }}>*</span></label>
            <select
              required
              value={verificationType}
              onChange={(e) => setVerificationType(e.target.value)}
            >
              <option value="">{translations[cpvLanguage].select}</option>
              <option value="Office/Business">{translations[cpvLanguage].officeBusiness}</option>
              <option value="Residence">{translations[cpvLanguage].residence}</option>
              <option value="ResiCumBusiness">{translations[cpvLanguage].resiCumBusiness}</option>
            </select>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: ".5rem",
            }}
          >
            <button className="btn-login" type="submit">
              Proceed
            </button>
          </div>
        </form>
      </div>
      <ToastContainer />
    </div>
  );
}
